export const activeDraftLocalStorageId = "SundaySkyStudioActiveFrameworkDraftId";
